import script from "./SmallPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./SmallPopup.vue?vue&type=script&setup=true&lang=js"

import "./SmallPopup.vue?vue&type=style&index=0&id=a1477200&lang=scss"

const __exports__ = script;

export default __exports__